import React from "react";
import { useNavigate } from "react-router-dom";
import useScrollTop from "../../utils/useScrollTop";

const PageNotFound = () => {
  const navigate = useNavigate();
  useScrollTop();
  return (
    <div className="app-container isolate mb-[-100px] min-h-screen  px-6  py-24 pt-[100px] pb-[60px] sm:py-32 lg:px-8 ">
      <div
        aria-hidden="true"
        className="absolute inset-0 -z-10 transform-gpu overflow-hidden blur-3xl"
      >
        <div
          style={{
            clipPath:
              "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
          }}
          className="relative left-1/2 top-1/2 -z-10 aspect-[1155/678] w-[36.125rem] max-w-none -translate-x-1/2 -translate-y-1/2 rotate-[30deg] bg-gradient-to-tr from-[#9089fc] to-[#ff80b5] opacity-30 sm:w-[72.1875rem]"
        />
      </div>

      <div className="w-full justify-center text-center">
        <h1
          className="relative text-[150px] font-[700]"
          style={{
            background: `linear-gradient(135deg, #231c42 50%, #f2673a 50%)`,
            WebkitBackgroundClip: "text",
            color: "transparent",
            position: "relative",
            display: "inline-block",
          }}
        >
          404
        </h1>

        <p className="font-[400] text-gray-500 max-md:text-[18px] lg:text-[20px] ">
          Oops! The page you're looking for doesn't exist.
        </p>
        <p className="text-[20px] font-[400] text-gray-500 ">
          Please check the URL or contact us for assistance.
        </p>
        <div className="mt-6 flex justify-center gap-2">
          <button
            className="cursor-pointer rounded-[6px]  border-[2px] border-[#F2673A] px-[10px] py-[7px] font-open text-[16px] font-[600] tracking-[0.003px] text-[#F2673A] hover:border-[#f2683ac7] max-md:w-[130px] md:px-[32px] md:py-[7px]"
            onClick={() => navigate("/")}
          >
            Home
          </button>
          <button
            className="cursor-pointer rounded-[6px]  bg-[#F2673A] px-[20px] py-[7px] font-open text-[16px] font-[600] tracking-[0.003px] text-[#ffffff] hover:bg-[#f2683acf] max-md:w-[130px] md:px-[32px] md:py-[7px]"
            onClick={() => navigate("/contact")}
          >
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
